angular.module('myApp.askLocal', ['ngRoute'])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/asklocal', {
            templateUrl: 'components/Asklocal/askLocal.html',
            controller: 'askLocalCtrl'
        })
    }])
        .controller('askLocalCtrl', ['$scope','$rootScope','$window', '$timeout','MetaService',function( $scope,$rootScope, $window,$timeout,MetaService) {
            $window.scrollTo(0, 0);
                   $rootScope.metaservice = MetaService;
      $rootScope.metaservice.set("Jugnoo Asklocal - City's Social Network","Discover, share, connect and keep up with what’s going on in your city","Social, Ask, Find, Share, Online");
             $scope.scrollTo=function () {
          $('html, body').animate({
              scrollTop: $(".downloadBackground").offset().top - 100
          }, 1000);
     }
            
        }]);
